module.exports = __webpack_public_path__ + "assets/img/image_317.1e4fbbf1.png";